// extracted by mini-css-extract-plugin
export default {"space":"SignIn_space__xjnL+","content":"SignIn_content__+r-Fz"};